<template>
  <v-dialog
    v-model="agregarSancionDialog"
    width="40%"
  >
    <template #activator="{ on, attrs }">
      <v-btn
        rounded
        small
        color="secondary"
        class="d-inline ml-4"
        v-bind="attrs"
        v-on="on"
        @click="agregarSancionDialog = true"
      >
        Agregar sanción
      </v-btn>
    </template>
    <v-card
      color="primary"
      tile
    >
      <v-card-title>
        <div class="text-h6">
          Nueva sanción administrativa
        </div>
        <v-spacer />
        <v-btn
          icon
          color="error"
          @click="agregarSancionDialog = false"
        >
          <v-icon>mdi-window-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          v-model="sancionForm"
        >
          <v-container>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  v-model="sancion.folio"
                  label="Folio"
                  color="secondary"
                  background-color="primary"
                  rounded
                  filled
                  dense
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="sancion.motivo"
                  label="Motivo"
                  color="secondary"
                  background-color="primary"
                  rounded
                  filled
                  dense
                  :rules="required"
                />
              </v-col>
              <v-col
                cols="12"
                align="center"
              >
                <div class="text-subtitle2 font-weight-bold">
                  Fecha de sanción
                </div>
                <v-date-picker
                  v-model="sancion.fechaSancion"
                  :rules="required"
                  locale="es"
                  color="secondary"
                  no-title
                  full-width
                />
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn
          rounded
          color="secondary"
          :disabled="!sancionForm || loading"
          @click="triggerSaveSancion()"
        >
          Guardar sanción
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions } from 'vuex';
import moment from 'moment';

export default {
  props: {
    idPersonal: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      agregarSancionDialog: false,

      sancionForm: false,
      loading: false,

      sancion: {
        fk_idPersonal: this.idPersonal,
        fechaSancion: null,
        folio: '',
        motivo: '',
      },

      required: [(v) => !!v || 'Este campo es requerido.'],
    };
  },

  computed: {
    getMaxDay() {
      return moment().format('YYYY-MM-DD');
    },
  },

  methods: {
    ...mapActions('vehiculos', ['saveVehiculo', 'fetchVehiculos']),
    ...mapActions('sancionesAdministrativas', ['saveSancionesAdministrativas', 'fetchSancionesAdministrativas']),

    async triggerSaveSancion() {
      this.loading = true;

      await this.saveSancionesAdministrativas({
        fk_idPersonal: this.idPersonal,
        fechaSancion: moment(this.sancion.fechaSancion).format('DD/MM/YYYY'),
        folio: this.sancion.folio,
        motivo: this.sancion.motivo,
      });

      this.closeDialog();
    },

    async closeDialog() {
      this.loading = false;
      this.sancion = {
        fk_idPersonal: this.idPersonal,
        fechaSancion: null,
        folio: '',
        motivo: '',
      };
      this.agregarSancionDialog = false;
      this.$refs.form.resetValidation();
      await this.fetchSancionesAdministrativas(this.idPersonal);
    },
  },
};
</script>
